import {request, serviceUrl} from "@/utils/request";

//告警趋势
export function getAlarmRecordTendency(spaceId, tagId, typeParam) {
    return request({
        params: {
            spaceId,
            tagId,
            typeParam
        },
        url: serviceUrl.deviceService + '/alarm/record/get-list-in-week'
    })
}

//告警历史
export function historyList(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/record/historyList',
        data: params
    })
}

// 获取告警列表文件
export function exportToExcel(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/record/export-excel',
        data: params,
        responseType: 'arraybuffer'
    })
}